import { Component, OnInit, Input, SimpleChanges, OnChanges } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { ApiService } from '@quorum/api';
import { ServiceLaneFacade } from '@quorum/service-lane-root/facade';

@Component({
  selector: 'svc-chrysler-dashboard',
  templateUrl: './chrysler-dashboard.component.html',
  styleUrls: ['./chrysler-dashboard.component.scss'],
})
export class ChryslerDashboardComponent implements OnInit, OnChanges {

  warningMessagesUi: any = { collapsed: false };
  recallInformationUi: any = { collapsed: true };
  warrantyWarningsUi: any = { collapsed: true };
  warrantyInformationUi: any = { collapsed: true };
  columnsToDisplay: string[] = ['type', 'original', 'deductible', 'expires', 'remaining'];
  @Input() collapsed: boolean;
  constructor(
    private apiService: ApiService,
    private route: ActivatedRoute,
    public serviceLaneFacade: ServiceLaneFacade
  ) {}

  ngOnInit() {
    console.log('CHRYSLER');
  }

  ngOnChanges(changes: SimpleChanges) {
    console.log('changes chrysler');
    console.log(changes);
    if (changes.collapsed.currentValue) {
      this.warningMessagesUi.collapsed = changes.collapsed.firstChange ? false : true;
      this.recallInformationUi.collapsed = true;
      this.warrantyWarningsUi.collapsed = true;
      this.warrantyInformationUi.collapsed = true;
    } else {
      this.warningMessagesUi.collapsed = false;
      this.recallInformationUi.collapsed = false;
      this.warrantyWarningsUi.collapsed = false;
      this.warrantyInformationUi.collapsed = false;
    }
  }

  toggleCollapse(groupUiObject: any) {
    groupUiObject.collapsed = !groupUiObject.collapsed;
  }

  isArray(array: any[]) {
    return Array.isArray(array);
  }
}
